import { render, staticRenderFns } from "./vehicleModel.vue?vue&type=template&id=5aaf88bc&"
import script from "./vehicleModel.vue?vue&type=script&lang=js&"
export * from "./vehicleModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aaf88bc')) {
      api.createRecord('5aaf88bc', component.options)
    } else {
      api.reload('5aaf88bc', component.options)
    }
    module.hot.accept("./vehicleModel.vue?vue&type=template&id=5aaf88bc&", function () {
      api.rerender('5aaf88bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/vehicleModel.vue"
export default component.exports